import { foldazApi } from 'api'
import get from 'just-safe-get'

import {
  FETCH_INVITATION_REQUEST,
  FETCH_INVITATION_SUCCESS,
  FETCH_INVITATION_ERROR,
  SET_INVITATION
} from './types'

export const state = {
  invitation: [],
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [FETCH_INVITATION_REQUEST] (state) {
    state.request.isLoading = true
  },
  [FETCH_INVITATION_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [FETCH_INVITATION_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_INVITATION] (state, value) {
    state.invitation = value
  }
}

export const actions = {
  confirmInvitation ({ commit, dispatch }, invitationId) {
    commit(FETCH_INVITATION_REQUEST)
    return foldazApi.get(`/invitations/${invitationId}`)
      .then(({data}) => commit(SET_INVITATION, data))
      .then(() => commit(FETCH_INVITATION_SUCCESS))
      .catch(error => {
        const statusCode = get(error, 'response.status')

        if (statusCode === 404) {
          commit(FETCH_INVITATION_ERROR, error)
        }
      })
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/invitations/invitation.js